import React, { lazy, Suspense, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { convertToCamelCase } from "../utils/helpers";
import ErrorBoundary from "../components/ErrorBoundary/ErrorBoundary";
import Spinner from "../components/Spinner/Spinner";
import { fetchPagesSections } from "../actions/pages-actions";
import { pagesActions } from "../store/pages-slice";
import { useParams } from "react-router-dom";
import SingleJobPostHeroSection from "../components/SingleJobPostHeroSection/SingleJobPostHeroSection";
import JobApplicationForm from "../components/JobApplicationForm/JobApplicationForm";

const loadComponent = (name) => {
  try {
    return lazy(() => import(`../components/${name}/${name}.js`));
  } catch (error) {
    console.error(`Failed to load component ${name}`, error);
    return null;
  }
};

const SingleJob = ({ slug }) => {
  const loading = useSelector((state) => state.pages.loadingData);
  const { postSlug } = useParams();
  const dispatch = useDispatch();

  const apiSlug = "job";
  const jobData = useSelector(
    (state) => state.pages.sections[apiSlug + postSlug]
  );

  useEffect(() => {
    if (!jobData) {
      dispatch(pagesActions.setLoadingData(true));
      dispatch(fetchPagesSections(apiSlug, postSlug));
    }
  }, [dispatch, apiSlug, jobData]);

  if (loading) {
    return <Spinner />;
  }

  return (
    <div className="single-job">
      <Suspense fallback={<Spinner />}>
        <SingleJobPostHeroSection data={jobData} />
        {jobData?.page_builder &&
          jobData?.page_builder.map((section, index) => {
            const componentName = convertToCamelCase(section.acf_fc_layout);
            const Component = loadComponent(componentName);

            return (
              <ErrorBoundary key={index}>
                {Component ? (
                  <Component key={index} data={section} />
                ) : (
                  <div>Component not found: {componentName}</div>
                )}
              </ErrorBoundary>
            );
          })}
        <JobApplicationForm data={jobData} />
      </Suspense>
    </div>
  );
};

export default SingleJob;
